/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './panel.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/shared/panel/panel.component';
const styles_PanelComponent:any[] = [i0.styles];
export const RenderType_PanelComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PanelComponent,data:{}});
function View_PanelComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'span',[['class',
      'glyphicon glyphicon-plus panel-control']],(null as any),[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.toggleMinimized()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any)))],(null as any),(null as any));
}
function View_PanelComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'span',[['class',
      'glyphicon glyphicon-minus panel-control']],(null as any),[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.toggleMinimized()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any)))],(null as any),(null as any));
}
function View_PanelComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'div',[['class',
      'panel-controls']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),0,'span',[['class','glyphicon glyphicon-refresh panel-control']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.refresh()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PanelComponent_2)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf'],ngIfElse:[1,'ngIfElse']},(null as any)),(_l()(),i1.ɵand(0,[['minimizeButton',
          2]],(null as any),0,(null as any),View_PanelComponent_3)),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),0,'span',[['class','glyphicon glyphicon-remove panel-control']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.toggleClosed()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any)))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.isMinimized;
    const currVal_1:any = i1.ɵnov(_v,5);
    _ck(_v,4,0,currVal_0,currVal_1);
  },(null as any));
}
function View_PanelComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,[[1,0],['header',1]],(null as any),1,'div',[['class',
      'panel-heading']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵncd((null as any),0)],(null as any),(null as any));
}
function View_PanelComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'panel-body']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵncd((null as any),1)],(null as any),(null as any));
}
function View_PanelComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,[[2,0],['footer',1]],(null as any),1,'div',[['class',
      'panel-footer']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵncd((null as any),2)],(null as any),(null as any));
}
export function View_PanelComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(671088640,1,{headerEl:0}),i1.ɵqud(671088640,2,{footerEl:0}),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PanelComponent_1)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),6,
          'div',[['class','panel']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_PanelComponent_4)),i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_PanelComponent_5)),i1.ɵdid(16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_PanelComponent_6)),i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i3.PanelComponent = _v.component;
    const currVal_0:any = _co.showControls;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.showHeader;
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = _co.showBody;
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = _co.showFooter;
    _ck(_v,10,0,currVal_3);
  },(null as any));
}
export function View_PanelComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),View_PanelComponent_0,RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export const PanelComponentNgFactory:i1.ComponentFactory<i3.PanelComponent> = i1.ɵccf('admin-panel',
    i3.PanelComponent,View_PanelComponent_Host_0,{showHeader:'showHeader',showFooter:'showFooter',
        showControls:'showControls',showBody:'showBody',headerColor:'headerColor',
        footerColor:'footerColor',tabbed:'tabbed'},{},['header','*','footer']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/panel/panel.component.ngfactory.ts